/**
 * The context menus' icons, drawn as one set in the account menu's line: an
 * emoji is in colour and a text glyph sits wherever each style's font puts
 * it, so a menu mixing them looks like two menus.
 */
const icon = { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true } as const;

const PATHS = {
  pin: (
    <>
      <path d="M9 4h6l-1 5 3 3v2H7v-2l3-3z" />
      <path d="M12 14v6" />
    </>
  ),
  unpin: (
    <>
      <path d="M9 4h6l-1 5 3 3v2H7v-2l3-3z" />
      <path d="M12 14v6M4 4l16 16" />
    </>
  ),
  folder: <path d="M3.5 7.5a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" />,
  section: <rect x="6" y="6" width="12" height="12" rx="3" />,
  plus: <path d="M12 5v14M5 12h14" />,
  unread: <circle cx="12" cy="12" r="3.5" fill="currentColor" />,
  edit: <path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16zM13.5 6.5l4 4" />,
  duplicate: (
    <>
      <rect x="8.5" y="8.5" width="11" height="11" rx="2" />
      <path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2" />
    </>
  ),
  copy: (
    <>
      <rect x="7" y="3.5" width="10" height="4" rx="1.2" />
      <path d="M7 5.5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-11a2 2 0 0 0-2-2h-1M8.5 12h7M8.5 16h5" />
    </>
  ),
  hide: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M6.5 17.5l11-11" />
    </>
  ),
  show: (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  trash: <path d="M4.5 7h15M10 11v6M14 11v6M9 7V4.5h6V7M6.5 7l1 12.5h9l1-12.5" />,
  reply: <path d="M10 6 5 11l5 5M5 11h9a5 5 0 0 1 5 5v2" />,
  up: <path d="M12 19V5M6 11l6-6 6 6" />,
  down: <path d="M12 5v14M6 13l6 6 6-6" />,
} as const;

export type MenuIconName = keyof typeof PATHS;

export function MenuIcon({ name }: { readonly name: MenuIconName }): React.JSX.Element {
  return <svg {...icon}>{PATHS[name]}</svg>;
}
